import { Link, Navigate, useSearchParams } from "react-router-dom"

export function HomePage() {
  const [searchParams] = useSearchParams()

  // Strongest deep-link: if someone lands on / with ?code=ABCDEF
  // (shared in iMessage/Slack/etc.) skip the chooser entirely and
  // hand straight to /r/CODE, which already has its own name form.
  const incomingCode = searchParams.get("code")?.trim().toLocaleUpperCase()
  if (incomingCode && /^[A-Z0-9]{6}$/.test(incomingCode)) {
    return <Navigate to={`/r/${incomingCode}`} replace />
  }

  return (
    <main
      id="main"
      className="mx-auto flex min-h-dvh w-full max-w-md flex-col bg-background text-foreground"
    >
      {/*
        The card IS the masthead and the visual hero. H1 lives inside it so
        the semantic hero and visual hero are the same element. No separate
        wordmark above the card — the card carries the brand. Sub-line is
        a single declarative sentence; no tagline floats beneath the card
        competing for attention.
      */}
      <header className="px-5 pt-8">
        <div
          className="border-4 border-foreground bg-card px-5 py-8"
          style={{ boxShadow: "var(--shadow-brutal)" }}
        >
          <h1 className="text-center font-display text-5xl uppercase leading-[0.9] tracking-tight">
            Bible
            <br />
            <span className="text-primary">Imposter</span>
          </h1>
          <p className="prose-body mt-5 text-center text-base leading-snug text-foreground">
            One of you is faking it. Find them.
          </p>
          <p className="mt-6 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
            3–8 players · ~10 min · Biblical
          </p>
        </div>
      </header>

      {/*
        CTAs in the thumb zone. Two actions, no eyebrow label — the card
        above already establishes context ("you are about to play"). Only
        secondary link is the rules bridge to /how-to-play, which carries
        the long-form indexable content.
      */}
      <section className="flex flex-col gap-3 px-5 pt-8">
        <Link
          to="/create"
          data-slot="button"
          className="flex h-16 items-center justify-center bg-primary px-4 text-base text-primary-foreground hover:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
        >
          Host a game
        </Link>
        <Link
          to="/join"
          data-slot="button"
          className="flex h-16 items-center justify-center border-2 border-border bg-transparent px-4 text-base text-foreground hover:bg-card focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
        >
          Join a game
        </Link>
        <Link
          to="/how-to-play"
          className="mt-1 text-center text-[11px] uppercase tracking-[0.25em] text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
        >
          How to play →
        </Link>
      </section>

      <div className="mt-auto">
        <footer className="brutalist-rule" />
        <div className="flex items-center justify-between px-5 py-4 text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
          <p>
            Made with <span aria-label="love" role="img">❤️</span> by{" "}
            <a
              href="https://www.linkedin.com/in/abiel-kidane-228a76206/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground underline-offset-2 hover:underline"
            >
              Abiel
            </a>
          </p>
          <Link to="/settings" className="text-foreground underline-offset-2 hover:underline">
            Privacy
          </Link>
        </div>
      </div>
    </main>
  )
}
